import { render } from "./SettingsEmailsTemplatesForm.vue?vue&type=template&id=65832dec&scoped=true"
import script from "./SettingsEmailsTemplatesForm.vue?vue&type=script&lang=js"
export * from "./SettingsEmailsTemplatesForm.vue?vue&type=script&lang=js"

import "./SettingsEmailsTemplatesForm.vue?vue&type=style&index=0&id=65832dec&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65832dec"]])

export default __exports__